import { createContext, useContext } from 'react';
import { type FlagName } from './registry';
import { type Overrides } from './overrides';

export interface FeatureFlags {
  flags: Record<FlagName, boolean>;
  resolved: Record<FlagName, boolean>;
  overrides: Overrides;
  setOverride: (name: FlagName, value: boolean | undefined) => void;
  resetOverrides: () => void;
}

export const FeatureFlagsContext = createContext<FeatureFlags | null>(null);

export const useFeatureFlags = (): FeatureFlags => {
  const values = useContext(FeatureFlagsContext);
  if (values === null) {
    throw new Error('FeatureFlagsContext not initialized');
  }
  return values;
};
